import {
	Grid,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
} from '@material-ui/core';
import { width } from '@mui/system';
import dayjs from 'dayjs';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { checkDepositSchedule } from '../../../../../api/Agreement/checkDepositSchedule.api';
import { getDepositBreakdown } from '../../../../../api/Agreement/getDepositBreakdown.api';
import { getDepositScheduleAPI } from '../../../../../redux/agreement/actions';
import { capitalizeFirstLetter } from '../../../../../utils/capitalizeFirstLetter';
import { numberWithCommas } from '../../../../../utils/numberWithCommas';
import { stringifyNumber } from '../../../../../utils/stringifyNumber';
import EditPricingDeposit from './EditPricingDeposit/EditPricingDeposit';
import styles from './Pricing.module.scss';
import _ from 'lodash';

const Pricing = ({
	modelName,
	lotNumber,
	lotSizeType,
	lotSize,
	elevation,
	modelPrice,
	grade,
	upgrade,
	lotPrice,
	options,
	totalOptions,
	editMode,
	getDepositScheduleAPI,
	depositSchedule,
	depositScheduleData,
	setDepositScheduleData,
	saveEditOnPrice,
	setSaveEditOnPrice,
	printMode,
}) => {
	const [totalCost, setTotalCost] = useState(0);
	const [depositBreakdowns, setDepositBreakdowns] = useState([]);
	const [totalPercent, setTotalPercent] = useState(0);
	const [totalInstallment, setTotalInstallment] = useState(0);
	var params = useParams();
	var optionArr = _.toArray(options);
	useLayoutEffect(() => {
		console.log(
			'total cost',
			Number(modelPrice),
			Number(lotPrice),
			Number(grade?.price || 0),
			Number(upgrade?.price || 0),
			Number(totalOptions)
		);
		let total =
			Number(modelPrice) +
			Number(lotPrice) +
			Number(grade?.price || 0) +
			Number(upgrade?.price || 0) +
			Number(totalOptions);

		setTotalCost(total);
		checkDepositSchedule(params.id, (data) => {
			console.log('This is the data check', data, totalOptions);
			if (!data) {
				console.log(
					'I do not have deposit breakdown. Creating one now...',
					modelPrice,
					lotPrice,
					totalOptions
				);
				if (
					Number(modelPrice) !== null &&
					Number(lotPrice) !== null &&
					Number(totalOptions) !== null
				) {
					var deposits = getDepositBreakdown(
						params.id,
						Number(modelPrice) +
							Number(lotPrice) +
							Number(grade?.price || 0) +
							Number(upgrade?.price || 0) +
							Number(totalOptions)
					);
					var depositTotal = 0;
					var percentageTotal = 0;
					deposits?.forEach((deposit) => {
						var installment = Number(deposit?.installment);
						var percentage = Number(deposit?.percentage);
						depositTotal = depositTotal + installment;
						percentageTotal = percentageTotal + percentage;
					});
					setTotalPercent(percentageTotal);
					setTotalInstallment(depositTotal);
					console.log('depokkkooiosits', deposits);
					setDepositBreakdowns(deposits);
				}

				getDepositScheduleAPI(params.id);
			} else {
				console.log('I already have a break down..', depositSchedule);

				console.log(
					'This is the deposite schedule data',
					depositSchedule
				);
				var depositScheduleKeys = Object.keys(depositSchedule);

				var installmentTotal = 0;
				var percentageTotal = 0;

				depositScheduleKeys.forEach((key) => {
					var installment = depositSchedule[key]['installment'];
					var percentage = depositSchedule[key]['percentage'];

					installmentTotal = parseFloat(
						Number(installmentTotal) + Number(installment)
					);
					percentageTotal = parseFloat(
						Number(percentageTotal) + Number(percentage || 0)
					);
				});

				setTotalInstallment(installmentTotal);
				setTotalPercent(percentageTotal);

				getDepositScheduleAPI(params.id);
			}
		});
	}, [modelPrice, lotPrice, totalOptions, grade, upgrade]);

	useEffect(() => {
		console.log('This is teh lot price', lotPrice);
	}, [lotPrice]);

	useEffect(() => {
		if (depositSchedule && depositSchedule.length > 0) {
			let depositScheduleKeys = Object.keys(depositSchedule);
			let installmentTotal = 0;
			let percentageTotal = 0;
			depositScheduleKeys.forEach((key) => {
				let installment = depositSchedule[key]['installment'];
				let percentage = depositSchedule[key]['percentage'];

				installmentTotal = parseFloat(
					Number(installmentTotal) + Number(installment)
				);
				percentageTotal = parseFloat(
					Number(percentageTotal) + Number(percentage || 0)
				);
			});

			setTotalInstallment(installmentTotal);
			setTotalPercent(percentageTotal);
		}
	}, [depositSchedule]);

	return (
		<div
			className={styles.pricing_wrapper}
			style={printMode && { width: '100%' }}
		>
			<Grid container className={styles.section}>
				<Grid item xs={2} className={styles.title}>
					Costs
				</Grid>
				<Grid item xs={10} className={styles.content}>
					<Grid item className={styles.lot_details} xs={2}>
						<div className={styles.model_title}>{modelName}</div>
						<div className={styles.model_subtitle}>
							{lotSizeType}" Lot
						</div>

						<div className={styles.model_text_group}>
							<div className={styles.lot_number}>
								Lot {lotNumber}
							</div>
							<div className={styles.lot_size}>
								{lotSize} Sqft
							</div>
							{/* <div className={styles.bedroom}>4 Bedrooms</div> */}
							<div className={styles.elevation}>
								Elevation {elevation}
							</div>
						</div>
					</Grid>

					<Grid item className={styles.pricing_card} xs={10}>
						<div className={styles.price_item}>
							<div className={styles.label}>Model Price</div>
							<div className={styles.field}>
								$ {numberWithCommas(Number(modelPrice))}
							</div>
						</div>
						<hr className={styles.separator}></hr>
						<div className={styles.price_item}>
							<div className={styles.label}>Total Premium</div>
							<div className={styles.field}>
								${' '}
								{numberWithCommas(
									Number(lotPrice) +
										Number(grade?.price || 0) +
										Number(upgrade?.price || 0)
								)}
							</div>
						</div>

						<div className={styles.price_item}>
							<div className={styles.sub_label}>Lot Price</div>
							<div className={styles.sub_field}>
								$ {numberWithCommas(lotPrice || lotPrice)}
							</div>
						</div>
						{Number(grade?.price) > 0 && (
							<div className={styles.price_item}>
								<div className={styles.sub_label}>
									{grade?.name}
								</div>
								<div className={styles.sub_field}>
									$ {numberWithCommas(grade?.price)}
								</div>
							</div>
						)}

						{Number(upgrade?.price) > 0 && (
							<div className={styles.price_item}>
								<div className={styles.sub_label}>
									{upgrade?.name}
								</div>
								<div className={styles.sub_field}>
									$ {numberWithCommas(upgrade?.price)}
								</div>
							</div>
						)}
						<hr className={styles.separator}></hr>
						<div className={styles.price_item}>
							<div className={styles.label}>Unit Options</div>
							<div className={styles.field}>$ {totalOptions}</div>
						</div>
						{options &&
							optionArr?.map((option, index) => (
								<div className={styles.price_item} key={index}>
									<div className={styles.sub_label}>
										{option?.name}
									</div>
									<div className={styles.sub_field}>
										$ {numberWithCommas(option?.value)}
									</div>
								</div>
							))}

						<div className={styles.total_wrap}>
							<div className={styles.label}>Total</div>
							<div className={styles.field}>
								$ {numberWithCommas(Number(totalCost))}
							</div>
						</div>
					</Grid>
				</Grid>
			</Grid>

			<Grid container className={styles.section}>
				<Grid item xs={2} className={styles.title}>
					Deposit Schedule
				</Grid>
				<Grid
					item
					xs={10}
					className={`${styles.content} ${styles.table_wrapper}`}
					container
					direction='column'
				>
					{!editMode ? (
						<>
							<div className={styles.deposit_schedule_wrapper}>
								<Grid container>
									<Grid item container>
										<Grid item xs={3}></Grid>
										<Grid item xs={3}>
											Date
										</Grid>
										<Grid item xs={3}>
											%
										</Grid>
										<Grid item xs={3}>
											Amount
										</Grid>
									</Grid>
									{depositSchedule?.map((deposit, key) => {
										var depositNumber = key + 1;

										return (
											<>
												<hr
													className={styles.separator}
												></hr>
												<Grid item container>
													<Grid item xs={3}>
														{capitalizeFirstLetter(
															stringifyNumber(
																depositNumber
															)
														)}{' '}
														deposit
													</Grid>
													<Grid item xs={3}>
														{dayjs(
															deposit?.date
														).format(
															'MMM DD, YYYY'
														)}
													</Grid>
													<Grid item xs={3}>
														{deposit?.percentage
															? deposit?.percentage
															: 'N/A'}
													</Grid>
													<Grid item xs={3}>
														$
														{numberWithCommas(
															Number(
																deposit?.installment
															)
														)}
													</Grid>
												</Grid>
											</>
										);
									})}
								</Grid>
							</div>
							<div className={styles.total_wrapper}>
								<Grid container>
									<Grid item container>
										<Grid item xs={3}>
											Total Deposit
										</Grid>
										<Grid item xs={3}></Grid>
										<Grid item xs={3}>
											{totalPercent.toFixed(1)}%
										</Grid>
										<Grid item xs={3}>
											${' '}
											{numberWithCommas(
												totalInstallment.toFixed(2)
											)}
										</Grid>
										{console.log(
											'This is hatg afaf',
											totalInstallment
										)}
									</Grid>
								</Grid>
							</div>
						</>
					) : (
						<EditPricingDeposit
							depositSchedule={depositSchedule}
							totalCost={totalCost}
							depositScheduleData={depositScheduleData}
							setDepositScheduleData={setDepositScheduleData}
							saveEditOnPrice={saveEditOnPrice}
							setSaveEditOnPrice={setSaveEditOnPrice}
						/>
					)}
				</Grid>
			</Grid>
		</div>
	);
};
const mapStateToProps = (state) => ({
	modelName:
		state.agreement?.productAvailability?.modelName ||
		state.agreement?.agreementById?.productAvailability?.modelName,
	lotNumber:
		state.agreement?.productAvailability?.lotId ||
		state.agreement?.agreementById?.productAvailability?.lotId,
	lotSizeType:
		state.agreement?.productAvailability?.lotSizeType ||
		state.agreement?.agreementById?.productAvailability?.lotSizeType,
	lotSize:
		state.agreement?.productAvailability?.lotSize ||
		state.agreement?.agreementById?.productAvailability?.lotSize,
	elevation:
		state.agreement?.productAvailability?.elevation?.id ||
		state.agreement?.agreementById?.productAvailability?.elevation?.id,
	modelPrice:
		state.agreement?.productAvailability?.elevation?.price ||
		state.agreement?.agreementById?.productAvailability?.elevation?.price,
	grade:
		state.agreement?.productAvailability?.grade ||
		state.agreement?.agreementById?.productAvailability?.grade,
	upgrade:
		state.agreement?.productAvailability?.upgrade ||
		state.agreement?.agreementById?.productAvailability?.upgrade,
	lotPrice:
		state.agreement?.productAvailability?.lotPrice ||
		state.agreement?.agreementById?.productAvailability?.lotPrice,
	options: state.agreement?.agreementById?.options,
	totalOptions: state.agreement?.agreementById?.totalOptions,
	depositSchedule: state.agreement.depositSchedule,
});

export default connect(mapStateToProps, { getDepositScheduleAPI })(Pricing);
